module.exports = __webpack_public_path__ + "img/funnel-plot.89f00f06.svg";